
import '../../index.css'

const Spiner = () => {

    return (
        <div className="spinner container">  📚
         </div>
       
    )
}

export default Spiner


